module.exports = __webpack_public_path__ + "img/auto_spin_btn.f6cdce24.png";